import ButtonPrimaryAsLink from './variations/ButtonPrimaryAsLink';
import ButtonSecondaryAsLink from './variations/ButtonSecondaryAsLink';
import ButtonTertiaryAsLink from './variations/ButtonTertiaryAsLink';
import ButtonDestructiveAsLink from './variations/ButtonDestructiveAsLink';
export * from './ButtonAsLink';

export {
	ButtonPrimaryAsLink,
	ButtonSecondaryAsLink,
	ButtonTertiaryAsLink,
	ButtonDestructiveAsLink,
};
